// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rfaMvw3fKk1cuWUsdfzb {
  gap: 0.25rem;
  height: 300px;
  width: 45%;
  display: flex;
  flex-direction: column;
}

.TY_dWY4X1KA8g33ucgkY {
  width: 100%;
  height: 100%;
}

.OJDz3V4SP_U7chBUXxVe {
  resize: none;
  height: 95%;
  outline: none;
  border: 1px solid #d3d7e4;
  border-radius: 4px;
  padding-left: 16px;
  padding-right: 0;
  padding-top: 0.65625rem;
  color: #373f55;
  font-weight: 400;
  font-size: 0.875rem;
  display: block;
  width: 100%;
  background: inherit;
}

.OJDz3V4SP_U7chBUXxVe:disabled {
  border: 1px solid #d3d7e4;
  transition-duration: 0.2s;
  color: #4c597d;
  background: #ebedf3;
}

.OJDz3V4SP_U7chBUXxVe:focus {
  outline-offset: 0;
}

.OJDz3V4SP_U7chBUXxVe:focus-visible {
  outline-offset: 0;
}

.INSz6p6Aj9mNwSrjiEnL {
  display: flex;
  align-self: start;
  align-items: center;
  font-size: 0.75rem;
  line-height: 1.33;
  font-weight: 600;
  color: #373F55;
}
`, "",{"version":3,"sources":["webpack://./src/plugins/wysiwyg/admin/src/components/GlossaryTermsModal/components/DefinitionInput/DefinitionInput.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":[".wrapper {\n  gap: 0.25rem;\n  height: 300px;\n  width: 45%;\n  display: flex;\n  flex-direction: column;\n}\n\n.inputWrapper {\n  width: 100%;\n  height: 100%;\n}\n\n.definitionInput {\n  resize: none;\n  height: 95%;\n  outline: none;\n  border: 1px solid #d3d7e4;\n  border-radius: 4px;\n  padding-left: 16px;\n  padding-right: 0;\n  padding-top: 0.65625rem;\n  color: #373f55;\n  font-weight: 400;\n  font-size: 0.875rem;\n  display: block;\n  width: 100%;\n  background: inherit;\n}\n\n.definitionInput:disabled {\n  border: 1px solid #d3d7e4;\n  transition-duration: 0.2s;\n  color: #4c597d;\n  background: #ebedf3;\n}\n\n.definitionInput:focus {\n  outline-offset: 0;\n}\n\n.definitionInput:focus-visible {\n  outline-offset: 0;\n}\n\n.definitionLabel {\n  display: flex;\n  align-self: start;\n  align-items: center;\n  font-size: 0.75rem;\n  line-height: 1.33;\n  font-weight: 600;\n  color: #373F55;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `rfaMvw3fKk1cuWUsdfzb`,
	"inputWrapper": `TY_dWY4X1KA8g33ucgkY`,
	"definitionInput": `OJDz3V4SP_U7chBUXxVe`,
	"definitionLabel": `INSz6p6Aj9mNwSrjiEnL`
};
export default ___CSS_LOADER_EXPORT___;
